import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress benign ResizeObserver loop errors
// This error occurs when ResizeObserver callbacks trigger additional resizes
// It's a known browser limitation and doesn't affect functionality
const resizeObserverErrorHandler = (event) => {
  const errorMessage = event.message || event.reason?.message || '';
  if (
    errorMessage.includes('ResizeObserver loop') ||
    errorMessage.includes('ResizeObserver loop completed with undelivered notifications') ||
    errorMessage.includes('ResizeObserver loop limit exceeded')
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
  return false;
};

// Add error listeners for different event types
window.addEventListener('error', resizeObserverErrorHandler);
window.addEventListener('unhandledrejection', resizeObserverErrorHandler);

// Override console.error to suppress ResizeObserver messages in development
const originalConsoleError = console.error;
console.error = (...args) => {
  const errorMessage = args[0]?.toString() || '';
  if (
    errorMessage.includes('ResizeObserver loop') ||
    errorMessage.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    return; // Suppress the error
  }
  originalConsoleError.apply(console, args);
};

// Disable React error overlay for ResizeObserver errors
if (process.env.NODE_ENV === 'development') {
  const originalErrorHandler = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (message && message.toString().includes('ResizeObserver')) {
      return true; // Prevent React error overlay
    }
    if (originalErrorHandler) {
      return originalErrorHandler(message, source, lineno, colno, error);
    }
    return false;
  };

  // Also suppress for React's error boundary
  const showErrorOverlay = window.__REACT_DEVTOOLS_GLOBAL_HOOK__?.showErrorOverlay;
  if (showErrorOverlay) {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.showErrorOverlay = function(...args) {
      const error = args[0];
      if (error?.message?.includes('ResizeObserver')) {
        return; // Don't show overlay
      }
      return showErrorOverlay.apply(this, args);
    };
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
